import { render, staticRenderFns } from "./MeshDevicePage.vue?vue&type=template&id=87d96afa&scoped=true&"
import script from "./MeshDevicePage.vue?vue&type=script&lang=js&"
export * from "./MeshDevicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d96afa",
  null
  
)

export default component.exports